import { ApplicationDocumentUploads } from '@components/ApplicationDocuments/ApplicationDocumentUploads';
import { useGetOrderApplicationDetailsQuery } from '@components/ApplicationDocuments/queries';
import { ITabData } from '@components/Tabs/types';
import { useI18n } from '@hooks/useI18n/useI18n';
import { Portals, TabEventKeys } from '@utils/constants';
import { CustomerDocumentsTabIcon } from './CustomerDocumentsTabIcon';

interface ICustomerDocumentsTab {
  externalContractUuid: string;
}

export const useCustomerDocumentsTab = ({
  externalContractUuid,
}: ICustomerDocumentsTab): ITabData => {
  const { translate } = useI18n();

  const {
    orderApplicationDetailsData,
    orderApplicationDetailsError,
    orderApplicationDetailsLoading,
  } = useGetOrderApplicationDetailsQuery({
    externalContractUuid,
    portal: Portals.OPS,
  });

  const showTab =
    orderApplicationDetailsData?.customer_agreement_signing_overview
      .is_manual_signing_required ||
    orderApplicationDetailsData?.manual_identity_upload_summary
      .is_manual_identity_document_upload_required;

  return {
    eventKey: TabEventKeys.CUSTOMER_DOCUMENTS,
    error: orderApplicationDetailsError,
    isLoading: orderApplicationDetailsLoading,
    component: showTab ? (
      <ApplicationDocumentUploads
        externalContractUuid={externalContractUuid}
        orderApplicationDetailsData={orderApplicationDetailsData}
        queryKey={[]}
        wrapInCard={false}
      />
    ) : null,
    title: (
      <>
        {translate('TITLE.CUSTOMER_DOCUMENTS')}
        <CustomerDocumentsTabIcon
          orderApplicationDetailsData={orderApplicationDetailsData}
        />
      </>
    ),
  };
};
